"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TUPLE_SEPARATOR = void 0;
exports.TUPLE_SEPARATOR = ",";
//# sourceMappingURL=dashboard-metrics.js.map